import React from "react";
import { Stack } from "@bookingcom/bui-react";
import { StopsFilterDesktop } from "./FiltersSplit/StopsFilter/index.js";
import { AirlinesFilterDesktop } from "./FiltersSplit/AirlinesFilter/index.js";
import { FlightTimesFilterDesktop } from "./FiltersSplit/FlightTimesFilter/index.js";
import { DurationFilter } from "./FiltersSplit/DurationFilter/index.js";
import { useGetAvailableFilters } from "../SearchResults/components/boundsFilterHooks.js";
import { LayoverDurationFilter } from "./FiltersSplit/LayoverDurationFilter/LayoverDurationFilter.js";
import AirportsFilter from "./FiltersSplit/AirportsFilter/AirportsFilter.js";
import { useTrackLayoverPriceAirportFilterWeb } from "../../../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
import { AppliedFilterChipsList } from "./FiltersSplit/AppliedFiltersChipsList.js";
import { BudgetPerAdultFilter } from "./FiltersSplit/BudgetPerAdultFilter/BudgetPerAdultFilter.js";
const SearchFiltersDesktop = () => {
    const availableFilters = useGetAvailableFilters();
    const trackLayoverPriceAirportFilterWeb = useTrackLayoverPriceAirportFilterWeb();
    return (React.createElement("div", { id: "search_filters_content_wrapper" }, Object.keys(availableFilters).length > 0 ? (React.createElement(Stack, { gap: trackLayoverPriceAirportFilterWeb() ? 4 : 8 },
        React.createElement(StopsFilterDesktop, null),
        React.createElement(AirlinesFilterDesktop, null),
        React.createElement(FlightTimesFilterDesktop, null),
        React.createElement(Stack, { gap: 0 },
            React.createElement(DurationFilter, null),
            trackLayoverPriceAirportFilterWeb() ? React.createElement(LayoverDurationFilter, null) : undefined),
        trackLayoverPriceAirportFilterWeb() ? (React.createElement(React.Fragment, null,
            React.createElement(BudgetPerAdultFilter, null),
            React.createElement(AirportsFilter, null))) : undefined,
        React.createElement(AppliedFilterChipsList, null))) : null));
};
export default SearchFiltersDesktop;
